module.exports = __webpack_public_path__ + "img/car.b168cf61.png";